export default __webpack_public_path__ + "static/media/admin_key.6f1e924e.png";